import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  SelectInput,
  useRedirect,
  useRefresh,
  CreateProps,
} from "react-admin";
import CustomLevelInput from "components/CustomLevelInput";
import { GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { statusList } from "pages/levels/util";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import CreateWrapper from "../../components/CreateWrapper";

const LevelGroupsCreate = (props: CreateProps) => {
  const redirect = useRedirect();
  const refresh = useRefresh();
  const param = GetParam();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Levels", link: `/schools/${param.get("schoolId")}/show/1` },
    {
      title: "Class",
      link: `/levels/${param.get("levelId")}/show`,
      params: `?schoolId=${param.get("schoolId")}`,
    },
    { title: "Create", link: "" },
  ];

  const CustomRedirect = (props: { data: ILevelGroup }) => {
    redirect(
      `/levels/${props.data.levelId}/show?schoolId=${param.get("schoolId")}`
    );
    refresh();
  };

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New Class"
        onSuccess={CustomRedirect}
        {...props}
      >
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Level</Typography>
            </Grid>
            <Grid item xs={4}>
              <CustomLevelInput />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={4}>
              <SelectInput
                source="status"
                choices={statusList}
                defaultValue="Active"
                validate={required()}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default LevelGroupsCreate;
